const LoadMoreStrutture = () => {
    const loadMoreButton = document.getElementById('load-more-ajax');
    if (!loadMoreButton) return;

    const loadMoreFunction = loadMoreButton.dataset.function;
    const loadMoreText = loadMoreButton.querySelector('.load-more-text');
    const loadingText = loadMoreButton.querySelector('.loading-text');
    const icon = loadMoreButton.querySelector('.icon-chevron-down');

    let page = 1;
    let loading = false;

    loadMoreButton.addEventListener('click', function() {
        if (loading) return;
        loading = true;
        
        // Mostra il testo di caricamento e nascondi il testo originale e l'icona
        loadMoreText.style.display = 'none';
        loadingText.style.display = 'inline';
        icon.style.display = 'none';

        page++;

        const data = new FormData();
        data.append('action', loadMoreFunction);
        data.append('page', page);
        data.append('nonce', rqst.NONCE);

        // Aggiungi i parametri extra alla richiesta AJAX
        data.append('tipologia', loadMoreButton.dataset.tipologia || '');
        data.append('regione', loadMoreButton.dataset.regione || '');
        data.append('provincia', loadMoreButton.dataset.provincia || '');
        data.append('citta', loadMoreButton.dataset.citta || '');
        data.append('servizi_plus', loadMoreButton.dataset.serviziPlus || '');
        data.append('professionista', loadMoreButton.dataset.professionista || '');
        data.append('servizio_struttura', loadMoreButton.dataset.servizioStruttura || '');

        fetch(rqst.AJAX_URL, {
            method: 'POST',
            body: data
        })
        .then(response => response.json())
        .then(data => {
            const container = document.getElementById('ajax-container');
            container.insertAdjacentHTML('beforeend', data.html);
            loading = false;

            loadMoreText.style.display = 'inline';
            loadingText.style.display = 'none';
            icon.style.display = 'inline';            
            if (data.loaded >= data.total) {
                loadMoreButton.style.display = 'none';
            }
        })
        .catch(error => {
            console.error('Error:', error);
            loading = false;

            loadMoreText.style.display = 'inline';
            loadingText.style.display = 'none';
            icon.style.display = 'inline';
        });
    });
};

export default LoadMoreStrutture;
